module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAEYCAYAAABoRRfeAAABZElEQVRoge3Sv07CUBTH8W9LexFqorujq7FojPoOOrJInP3zRPoAJgww+hIkxlDi6siuAyi3LdfhQkBkYXP4neSkbe755N5zegPnHADdDAPcAVfAAT7egDbw2EyxAIFzjm7GHvBsIhr1GKqRr54UMM7BFvSBy2bKMOj0nQF6dUNjtwaJATMDtoCRhY8vGFsy4CwCbk3ki+dgeYe44t+LKaktuImAVmJ8YWJgewnEoX/mJYwt2IJWBBybij9GdZbzIwHk08UacBSyWeQh8GpL3+BklrZY8136MUdAe2Q5r8WLBvPpoumRXSTQDjp9VwV6SZV0Z2v9WD+/YTRhAJz++XGJATPbyZYe2IIMuGimDIOVq3EPXIcBJwBTxwvwBDz8uhqrMXjHARzuE6yubTpWAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAYF/An4A1w2FoJmmnwMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/news_timeline.jpg
// module id = 2sqP
// module chunks = 1